import { Translations } from "../services/i18n-manager";

// Swedish translations
const sv: Translations = {
  // Navigation
  "nav.home": "Hem",
  "nav.products": "Produkter",
  "nav.contact": "Kontakt",
  "nav.account": "Konto",
  "nav.cart": "Varukorg",
  "nav.login": "Logga in",
  "nav.logout": "Logga ut",
  "nav.register": "Registrera",

  // Page metadata
  "page.title": "Novi Prints - 3D-utskriftslösningar",
  "page.description":
    "Professionella 3D-utskriftstjänster med anpassade designs och högkvalitativa material.",

  // Hero section
  "hero.title": "Personliga 3D-utskrifter",
  "hero.subtitle": "Förvandla dina idéer till verklighet",
  "hero.description":
    "Högkvalitativa 3D-utskriftstjänster med precisionshantverk och skräddarsydda designs för dina projekt.",
  "hero.cta": "Utforska produkter",
  "hero.title_line1": "Personliga",
  "hero.title_line2": "3D-utskrifter",

  // Categories
  "categories.title": "Kategorier",
  "categories.all": "Alla produkter",
  "categories.figures": "Figurer",
  "categories.prototypes": "Prototyper",
  "categories.decorations": "Dekorationer",
  "categories.tools": "Verktyg",

  // Products
  "products.loading": "Laddar produkter...",
  "products.not_found": "Inga produkter hittades",
  "products.try_different_category": "Prova en annan kategori",
  "products.view_details": "Visa detaljer",
  "products.add_to_cart": "Lägg i varukorg",
  "products.in_cart": "I varukorg",
  "products.out_of_stock": "Slut i lager",
  "products.price": "Pris",
  "products.quantity": "Antal",
  "products.options": "Alternativ",
  "products.select_options_required":
    "Vänligen välj produktalternativ innan du lägger till i varukorgen",

  // Product dialog
  "product.quantity": "Antal:",
  "product.details": "Produktdetaljer",
  "product.no_specifications": "Inga specifikationer tillgängliga",
  "product.add_to_cart": "Lägg i varukorg",
  "product.in_cart": "I varukorg",
  "product.options.color": "Färg",
  "product.options.size": "Storlek",
  "product.options.material": "Material",
  "product.options.finish": "Finish",
  "product.specs.dimensions": "Dimensioner",
  "product.specs.weight": "Vikt",
  "product.specs.material": "Material",
  "product.specs.color": "Färg",
  "product.specs.finish": "Finish",
  "product.specs.print_time": "Utskriftstid",
  "product.specs.layer_height": "Skikthöjd",
  "product.specs.infill": "Fyllning",

  // Cart
  "cart.title": "Varukorg",
  "cart.empty": "Din varukorg är tom",
  "cart.empty_description": "Lägg till några produkter för att komma igång",
  "cart.subtotal": "Delsumma",
  "cart.shipping": "Frakt",
  "cart.total": "Totalt",
  "cart.checkout": "Till kassan",
  "cart.continue_shopping": "Fortsätt handla",
  "cart.remove_item": "Ta bort artikel",
  "cart.update_quantity": "Uppdatera antal",
  "cart.item_removed": "Artikel borttagen från varukorg",

  // Checkout
  "checkout.title": "Kassa",
  "checkout.step.customer_info": "Kundinformation",
  "checkout.step.payment": "Betalning",
  "checkout.step.confirmation": "Bekräftelse",
  "checkout.email": "E-postadress",
  "checkout.name": "Fullständigt namn",
  "checkout.address": "Adress",
  "checkout.city": "Stad",
  "checkout.postal": "Postnummer",
  "checkout.country": "Land",
  "checkout.same_billing": "Faktureringsadress samma som leveransadress",
  "checkout.guest_checkout": "Gästkassa",
  "checkout.login": "Logga in",
  "checkout.continue_to_payment": "Fortsätt till betalning",
  "checkout.back": "Tillbaka",
  "checkout.complete_order": "Slutför beställning",
  "checkout.cancel": "Avbryt",
  "checkout.continue_shopping": "Fortsätt handla",
  "checkout.order_details": "Beställningsdetaljer",
  "checkout.order_number": "Beställningsnummer",
  "checkout.total_amount": "Totalt belopp",
  "checkout.confirmation_email":
    "Du kommer att få en bekräftelse via e-post inom kort.",
  "checkout.confirmation": "Bekräftelse",
  "checkout.guest": "Gästkassa",
  "checkout.login_prompt": "Har du redan ett konto?",
  "checkout.billing_address": "Faktureringsadress",
  "checkout.shipping_address": "Leveransadress",
  "checkout.same_as_billing": "Samma som faktureringsadress",
  "checkout.payment_method": "Betalningsmetod",
  "checkout.card_number": "Kortnummer",
  "checkout.expiry_date": "Utgångsdatum",
  "checkout.cvv": "CVV",
  "checkout.cardholder_name": "Kortinnehavarens namn",
  "checkout.place_order": "Slutför beställning",
  "checkout.order_success": "Beställning mottagen!",
  "checkout.login_required": "Vänligen logga in för att fortsätta med kassan",
  "checkout.payment_error":
    "Kunde inte initiera betalning. Vänligen försök igen.",
  "checkout.payment_not_ready":
    "Betalningssystemet är inte redo. Vänligen försök igen.",
  "checkout.processing": "Bearbetar...",
  "checkout.payment_failed": "Betalning misslyckades. Vänligen försök igen.",
  "checkout.order_confirmed": "Beställning bekräftad! Tack för ditt köp.",
  "checkout.order_failed":
    "Beställningsskapande misslyckades. Vänligen kontakta support.",
  "checkout.minimum_amount": "Minsta beställningsbelopp är 3,00 SEK",
  // duplicate removed

  // Account
  "account.title": "Mitt konto",
  "account.profile": "Profil",
  "account.orders": "Beställningar",
  "account.settings": "Inställningar",
  "account.logout": "Logga ut",
  "account.edit_profile": "Redigera profil",
  "account.save_changes": "Spara ändringar",
  "account.cancel": "Avbryt",
  "account.name": "Namn",
  "account.email": "E-post",
  "account.phone": "Telefon",
  "account.address": "Adress",
  "account.city": "Stad",
  "account.postal_code": "Postnummer",
  "account.country": "Land",
  "account.email_readonly": "E-postadressen kan inte ändras",
  "account.logout_description": "Logga ut från ditt konto",

  // Orders
  "orders.title": "Mina beställningar",
  "orders.no_orders": "Inga beställningar än",
  "orders.order_date": "Beställningsdatum",
  "orders.order_status": "Status",
  "orders.order_total": "Totalt",
  "orders.tracking_number": "Spårningsnummer",
  "orders.view_order": "Visa beställning",
  "orders.status.pending": "Väntar",
  "orders.status.processing": "Bearbetas",
  "orders.status.paid": "Betald",
  "orders.status.shipped": "Skickad",
  "orders.status.delivered": "Levererad",
  "orders.status.cancelled": "Avbruten",

  // Materials
  "materials.title": "Våra material",
  "materials.description":
    "Vi använder Polyterra PLA, ett premium miljövänligt material för alla våra utskrifter.",
  "materials.quality.title": "Premiumkvalitet",
  "materials.quality.description":
    "Polyterra PLA är en bioplast tillverkad av förnybara resurser som majs och sockerrör. Det erbjuder förbättrad seghet och matt finish, vilket säkerställer hållbarhet och estetisk attraktion.",
  "materials.environmental.title": "Miljöfördelar",
  "materials.environmental.description":
    "Genom att inkludera organiska material minskar Polyterra PLA plastinnehållet med cirka 40%. För varje rulle som säljs planteras ett träd, vilket bidrar till kolkompensering och främjar hållbarhet.",
  "materials.health.title": "Hälsa och säkerhet",
  "materials.health.description":
    "Polyterra PLA är biologiskt nedbrytbart under industriella komposteringsförhållanden och bryts ner till koldioxid, vatten, biomassa och mineralsalter utan att lämna giftiga rester. Säker för både användare och miljön.",

  // About
  "about.title": "Om oss",
  "about.paragraph1":
    "Novi är ett familjeägt företag som brinner för att skapa DIY-lösningar för miniatyrhus och miniatyrmöbler. Vår resa började med ett hjärtligt projekt—ett anpassat miniatyrhus till vår son—som tände vårt engagemang för att skapa glädje genom miniatyrer.",
  "about.paragraph2":
    "Vi erbjuder ett sortiment av produkter, från miniatyrmöbler till skräddarsydda miniatyrer, och är dedikerade till att tillhandahålla anpassade lösningar skräddarsydda för dina unika behov. Oavsett om du letar efter DIY-ideer för miniatyrmöbler, kompletta miniatyrhus eller andra specialiserade utskrifter, är vi här för att hjälpa dig förverkliga din vision.",
  "about.paragraph3":
    "Vårt mål är att tillhandahålla anpassade lösningar för dem som behöver det, såsom miniatyrer, modellering av hus, möbler och mer. Varje projekt är skapat med omsorg och uppmärksamhet på detaljer, vilket säkerställer kvalitetsresultat som förhoppningsvis överträffar förväntningarna.",

  // Contact
  "contact.title": "Kontakta oss",
  "contact.subtitle": "Anpassad utskriftsförfrågan",
  "contact.description":
    "Har du en anpassad design eller behöver något specifikt? Skicka oss dina krav så ger vi dig en offert för ditt projekt.",
  "contact.name": "Namn",
  "contact.email": "E-post",
  "contact.message": "Meddelande",
  "contact.files": "Filer (STL, Bilder)",
  "contact.file_upload_hint":
    "Dra och släpp filer här eller klicka för att bläddra",
  "contact.file_types": "STL-filer, bilder (JPG, PNG, WebP)",
  "contact.send_request": "Skicka förfrågan",
  "contact.success": "Förfrågan skickad!",
  "contact.success_message":
    "Tack för din förfrågan. Vi kommer att kontakta dig inom 24 timmar.",
  "contact.selected_files": "Valda filer",

  // Authentication
  "auth.dialog_title": "Logga in",
  "auth.login": "Logga in",
  "auth.register": "Registrera",
  "auth.login_tab": "Logga in",
  "auth.register_tab": "Registrera",
  "auth.name": "Namn",
  "auth.first_name": "Förnamn",
  "auth.last_name": "Efternamn",
  "auth.email": "E-post",
  "auth.password": "Lösenord",
  "auth.confirm_password": "Bekräfta lösenord",
  "auth.forgot_password": "Glömt lösenordet?",
  "auth.remember_me": "Kom ihåg mig",
  "auth.sign_in": "Logga in",
  "auth.create_account": "Skapa konto",
  "auth.already_have_account": "Har du redan ett konto?",
  "auth.dont_have_account": "Har du inget konto?",
  "auth.login_success": "Inloggning lyckades!",
  "auth.register_success": "Konto skapat!",
  "auth.logout_success": "Utloggning lyckades!",
  "auth.address": "Adress",
  "auth.city": "Stad",
  "auth.postal_code": "Postnummer",
  "auth.country": "Land",
  "auth.shipping_address": "Leveransadress",
  "auth.error.user_not_found": "Inget konto hittades med denna e-postadress",
  "auth.error.wrong_password": "Felaktigt lösenord",
  "auth.error.invalid_credential": "Ogiltig e-post eller lösenord",
  "auth.error.email_already_in_use":
    "Ett konto med denna e-postadress finns redan",
  "auth.error.weak_password": "Lösenordet måste vara minst 6 tecken",
  "auth.error.invalid_email": "Ogiltig e-postadress",
  "auth.error.user_disabled": "Detta konto har inaktiverats",
  "auth.error.too_many_requests":
    "För många misslyckade försök. Försök igen senare",
  "auth.error.network_error": "Nätverksfel. Kontrollera din internetanslutning",
  "auth.error.configuration_not_found":
    "Autentisering är inte konfigurerad. Kontakta support",
  "auth.error.operation_not_allowed":
    "Denna inloggningsmetod är inte aktiverad. Kontakta support",
  "auth.error.generic": "Ett fel uppstod. Försök igen",

  // GDPR
  "gdpr.data_export": "Exportera mina data",
  "gdpr.delete_account": "Ta bort konto",
  "gdpr.confirm_delete": "Ta bort ditt konto?",
  "gdpr.cannot_be_undone": "Denna åtgärd kan inte ångras.",
  "gdpr.data_exported": "Dina data har exporterats",
  "gdpr.account_deleted": "Ditt konto har tagits bort",
  "gdpr.title": "Datahantering",
  "gdpr.description": "Hantera dina personuppgifter enligt GDPR",
  "gdpr.delete_warning": "Alla dina data kommer att tas bort permanent",

  // Policies
  privacy_policy_title: "Integritetspolicy",
  privacy_policy_content:
    "Vi respekterar din integritet och skyddar dina personuppgifter enligt GDPR...",
  cookie_policy_title: "Cookie-policy",
  cookie_policy_content:
    "Vi använder cookies för att förbättra din upplevelse...",
  terms_title: "Användarvillkor",
  terms_content:
    "Genom att använda vår webbplats accepterar du dessa villkor...",

  // Privacy Policy
  "privacy.section1_title": "Introduktion",
  "privacy.section1_content":
    "Novi Prints ('vi', 'oss' eller 'vår') är dedikerade till att skydda din integritet. Denna integritetspolicy förklarar hur vi samlar in, använder, avslöjar och skyddar din information när du besöker vår webbplats och använder våra tjänster. Vänligen läs denna integritetspolicy noggrant. Om du inte håller med om villkoren i denna integritetspolicy, vänligen besök inte webbplatsen.",
  "privacy.section2_title": "Personuppgifter vi samlar in",
  "privacy.section2_content":
    "Vi samlar in information som du tillhandahåller direkt till oss när du skapar ett konto, lägger en beställning eller kontaktar oss. Detta inkluderar ditt namn, e-postadress, postadress (gatuadress, stad, postnummer och land) och lösenord. När du lägger en beställning samlar vi också in betalningsinformation via vår betalningsprocessorer Stripe (vi lagrar inte dina fullständiga betalningskortdetaljer). Om du skickar ett kontaktformulär samlar vi in ditt namn, e-postadress, meddelande och eventuella filer du laddar upp. Vi samlar inte in ditt telefonnummer om du inte tillhandahåller det frivilligt i ett kontaktmeddelande.",
  "privacy.section3_title": "Hur vi använder dina uppgifter",
  "privacy.section3_content":
    "Vi använder den information vi samlar in för att behandla och fullfölja dina beställningar, kommunicera med dig om dina beställningar (inklusive att skicka beställningsbekräftelser och leveransnotifikationer via e-post), svara på dina kontaktförfrågningar, hantera ditt konto, förbättra vår webbplats och tjänster, följa juridiska förpliktelser och för andra ändamål som avslöjas för dig vid tidpunkten för insamling. Vi skickar inte marknadsföringsmejl eller nyhetsbrev för närvarande.",
  "privacy.section4_title": "Datadelning och avslöjande",
  "privacy.section4_content":
    "Vi delar din betalningsinformation med Stripe, vår betalningsprocessorer, för att behandla betalningar. Stripe hanterar alla betalningstransaktioner och är PCI-DSS-kompatibel. Vi använder Firebase (Google) för autentisering och databastjänster, och SMTP-e-posttjänster (såsom Resend, Postmark eller SendGrid) för att skicka transaktionsmejl. Vi säljer inte din personliga information till tredje part. Vi kan avslöja din information om det krävs enligt lag eller för att skydda våra rättigheter eller våra användares säkerhet. Vid en företagsöverlåtelse eller fusion kan din information överföras som en del av den transaktionen.",
  "privacy.section5_title": "Datalagring och säkerhet",
  "privacy.section5_content":
    "Vi implementerar lämpliga tekniska och organisatoriska säkerhetsåtgärder för att skydda dina personuppgifter mot obehörig åtkomst, ändring, avslöjande eller förstörelse. Inget sätt att överföra över internet eller elektronisk lagring är dock helt säkert. Vi behåller dina personuppgifter endast så länge som det är nödvändigt för att uppfylla de ändamål som beskrivs i denna policy eller enligt lag.",
  "privacy.section6_title": "Dina rättigheter enligt GDPR",
  "privacy.section6_content":
    "Om du är bosatt i Europeiska ekonomiska området har du vissa dataskyddsrättigheter, inklusive rätten till åtkomst, rättelse, radering, begränsning av behandling, invändning mot behandling, dataportabilitet och att återkalla samtycke när som helst. För att utöva dessa rättigheter, vänligen kontakta oss med hjälp av den information som finns i kontaktsektionen. Vi kommer att svara på din begäran inom 30 dagar.",
  "privacy.section7_title": "Cookies och spårningsteknologier",
  "privacy.section7_content":
    "Vi använder cookies och liknande spårningsteknologier för att spåra aktivitet på vår tjänst och lagra viss information. Du kan instruera din webbläsare att vägra alla cookies eller indikera när en cookie skickas. Om du inte accepterar cookies kan du dock inte kunna använda vissa delar av vår tjänst. För mer information, vänligen granska vår Cookie-policy.",
  "privacy.section8_title": "Ändringar av denna integritetspolicy",
  "privacy.section8_content":
    "Vi kan uppdatera vår integritetspolicy från tid till annan. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya integritetspolicyn på denna sida och uppdatera 'Senast uppdaterad'-datumet. Du rekommenderas att granska denna integritetspolicy regelbundet för eventuella ändringar.",
  "privacy.contact_title": "Kontakta oss",
  "privacy.contact_content":
    "Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på info@noviprints.com. Vi kommer att göra allt för att svara på din begäran snabbt.",

  // Terms of Service
  "terms.section1_title": "Acceptering av villkor",
  "terms.section1_content":
    "Genom att komma åt och använda Novi Prints webbplats och tjänster accepterar och godkänner du att vara bunden av villkoren och bestämmelserna i detta avtal. Om du inte samtycker till att följa ovanstående, vänligen använd inte denna tjänst. Dessa användarvillkor gäller för alla användare av webbplatsen, inklusive men inte begränsat till användare som är webbläsare, leverantörer, kunder, handlare och/eller bidragsgivare av innehåll.",
  "terms.section2_title": "Användning av tjänsten",
  "terms.section2_content":
    "Du får endast använda vår webbplats för lagliga ändamål. Du samtycker till att inte använda våra tjänster för att sända, distribuera, lagra eller förstöra material i strid med någon tillämplig lag eller förordning. Förbjudna aktiviteter inkluderar, men är inte begränsade till, obehörig åtkomst till våra system, introduktion av virus eller skadlig kod, störning av tjänsteoperationer och kränkning av immateriella rättigheter.",
  "terms.section3_title": "Produktinformation och prissättning",
  "terms.section3_content":
    "Vi strävar efter att tillhandahålla korrekta produktbeskrivningar, prissättning och tillgänglighetsinformation. Vi garanterar dock inte att produktbeskrivningar eller annat innehåll på denna webbplats är korrekt, komplett, pålitligt, aktuellt eller felfritt. Priserna kan ändras utan förvarning. Vi förbehåller oss rätten att korrigera eventuella fel, felaktigheter eller utelämnanden och att ändra eller uppdatera information när som helst utan föregående meddelande.",
  "terms.section4_title": "Beställningar och betalning",
  "terms.section4_content":
    "Alla beställningar som görs via vår webbplats är beroende av vår godkännande. Vi förbehåller oss rätten att vägra eller avbryta vilken beställning som helst av vilken anledning som helst, inklusive men inte begränsat till produkt tillgänglighet, fel i prissättning eller produktinformation, eller bedrägerier. Betalning måste erhållas i förväg innan vi behandlar din beställning. Vi accepterar betalning via kreditkort, debetkort och digitala betalningsmetoder (såsom Apple Pay och Google Pay) via vår betalningsprocessorer Stripe. Alla priser är i SEK (svenska kronor) om inte annat anges. Minsta beställningsbelopp är 3,00 SEK.",
  "terms.section5_title": "Frakt och leverans",
  "terms.section5_content":
    "Fraktkostnader kommer att visas under kassan. Eftersom vi är ett litet 3D-utskriftsföretag, observera att leveranstider kan variera beroende på produktions tid för skräddarsydda artiklar. Leveranstider är endast uppskattningar och är inte garanterade. Risk för förlust och äganderätt för köpta produkter övergår dina vid leverans. Vi ansvarar inte för eventuella förseningar orsakade av fraktoperatörer eller tull. Internationella sändningar kan vara föremål för tullavgifter och importskatter, vilket är kundens ansvar.",
  "terms.section6_title": "Returer och återbetalningar",
  "terms.section6_content":
    "Om du inte är nöjd med ditt köp kan du returnera det inom 14 dagar efter leverans i original skick med köpbevis. Skräddarsydda eller personliga 3D-utskrivna artiklar kan inte vara berättigade till retur om de inte är defekta, eftersom varje artikel är skräddarsydd. För att initiera en retur, vänligen kontakta oss på info@noviprints.com. Återbetalningar kommer att behandlas till den ursprungliga betalningsmetoden via Stripe inom 14 arbetsdagar efter mottagande av den returnerade artikeln.",
  "terms.section7_title": "Immateriella rättigheter",
  "terms.section7_content":
    "Allt innehåll som ingår på denna webbplats, såsom text, grafik, logotyper, bilder och programvara, är Novi Prints eller dess innehållsleverantörers egendom och skyddas av upphovsrättslagar. Du får inte reproducera, distribuera, modifiera, skapa härledda verk från, offentligt visa eller på annat sätt använda något innehåll från denna webbplats utan vår uttryckliga skriftliga tillstånd.",
  "terms.section8_title": "Begränsning av ansvar",
  "terms.section8_content":
    "I största möjliga utsträckning enligt tillämplig lag ska Novi Prints inte vara ansvarig för några indirekta, tillfälliga, särskilda, konsekventa eller straffskadestånd, eller någon förlust av vinster eller intäkter, oavsett om de uppstått direkt eller indirekt, eller någon förlust av data, användning, goodwill eller andra immateriella förluster som uppstår från din användning av våra tjänster eller produkter.",
  "terms.section9_title": "Ändringar av villkor",
  "terms.section9_content":
    "Vi förbehåller oss rätten, efter eget gottfinnande, att modifiera eller ersätta dessa användarvillkor när som helst. Om en revision är väsentlig kommer vi att ge minst 30 dagars varsel innan eventuella nya villkor träder i kraft. Din fortsatta användning av våra tjänster efter eventuella ändringar innebär acceptans av dessa ändringar.",
  "terms.contact_title": "Kontaktinformation",
  "terms.contact_content":
    "Om du har några frågor om dessa användarvillkor, vänligen kontakta oss på info@noviprints.com. Vi kommer att svara på din förfrågan så snart som möjligt.",

  // Cookies
  "cookies.title": "Vi använder cookies",
  "cookies.description":
    "Vi använder cookies för att förbättra din upplevelse och analysera vår trafik. Genom att fortsätta använda vår webbplats samtycker du till vår användning av cookies.",
  "cookies.accept_all": "Acceptera alla",
  "cookies.customize": "Anpassa",
  "cookies.necessary": "Nödvändiga",
  "cookies.analytics": "Analys",
  "cookies.marketing": "Marknadsföring",
  "cookies.customize_title": "Cookie-inställningar",
  "cookies.customize_description":
    "Välj vilka typer av cookies du vill acceptera:",
  "cookies.necessary_description":
    "Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt.",
  "cookies.analytics_description":
    "Dessa cookies hjälper oss att förstå hur besökare interagerar med webbplatsen.",
  "cookies.marketing_description":
    "Dessa cookies används för att visa relevanta annonser.",
  "cookies.save_preferences": "Spara inställningar",
  "cookies.manage_preferences": "Hantera cookie-preferenser",
  "cookies.what_are_cookies": "Vad är cookies?",
  "cookies.what_are_cookies_content":
    "Cookies är små textfiler som placeras på din dator eller mobila enhet när du besöker en webbplats. Cookies används ofta för att göra webbplatser mer effektiva och ge information till webbplatsägare. Cookies gör att en webbplats kan känna igen din enhet och lagra viss information om dina preferenser eller tidigare åtgärder.",
  "cookies.how_we_use_cookies": "Hur vi använder cookies",
  "cookies.how_we_use_cookies_content":
    "Vi använder cookies och lokal lagring för att aktivera viktiga funktioner på webbplatsen, såsom att upprätthålla din inloggningssession, lagra dina cookie-preferenser och spara din varukorg. För närvarande använder vi endast nödvändiga cookies för att säkerställa att webbplatsen fungerar korrekt. Vi implementerar för närvarande inte analys- eller marknadsföringscookies, men vi ger alternativ för dessa i vårt cookie-samtyckessystem om vi skulle lägga till dem i framtiden.",
  "cookies.cookie_types": "Typer av cookies vi använder",
  "cookies.cookie_types_content": "Vi använder följande typer av cookies:",
  "cookies.necessary_details":
    "Nödvändiga cookies och lokal lagring är essentiella för att webbplatsen ska fungera korrekt. Dessa inkluderar sessionshantering (hålla dig inloggad), lagra dina cookie-samtyckespreferenser och spara din varukorg. Dessa cookies kan inte inaktiveras.",
  "cookies.analytics_details":
    "Medan vi ger ett alternativ att acceptera analyscookies implementerar vi för närvarande inga analysspårningsverktyg (såsom Google Analytics). Om vi lägger till analyser i framtiden skulle dessa cookies hjälpa oss att förstå hur besökare interagerar med vår webbplats anonymt.",
  "cookies.marketing_details":
    "Medan vi ger ett alternativ att acceptera marknadsföringscookies implementerar vi för närvarande ingen marknadsförings- eller annonsspårning. Om vi lägger till marknadsföringsverktyg i framtiden skulle dessa cookies användas för att leverera relevant innehåll.",
  "cookies.third_party_title": "Tredjepartscookies",
  "cookies.third_party_content":
    "Vi använder Stripe för betalningshantering, vilket kan sätta cookies som en del av deras betalningstjänster. Vi använder också Firebase för autentisering och databastjänster. Vi använder för närvarande inte tredjepartsanalys eller annonscookies.",
  "cookies.retention_title": "Cookie-förvaring",
  "cookies.retention_content":
    "Olika cookies och lokal lagringsdata har olika kvarhållningsperioder. Sessionscookies upphör när du stänger din webbläsare, medan beständiga cookies och lokal lagringsdata (såsom dina cookie-samtyckespreferenser) finns kvar på din enhet tills du rensar dina webbläsardata eller tar bort dem manuellt. Dina cookie-samtyckespreferenser lagras i din webbläsares lokal lagring tills du återkallar samtycke.",
  "cookies.manage_cookies": "Hantera dina cookie-preferenser",
  "cookies.manage_cookies_content":
    "Du kan kontrollera och/eller ta bort cookies som du vill. De flesta webbläsare accepterar automatiskt cookies, men du kan vanligtvis modifiera dina webbläsarinställningar för att avvisa cookies om du föredrar det. Du kan också ändra dina cookie-preferenser när som helst med hjälp av cookie-inställningsverktyget på vår webbplats. Observera att inaktivering av vissa cookies kan påverka funktionaliteten på vår webbplats.",

  // Common
  "common.loading": "Laddar...",
  "common.error": "Ett fel uppstod",
  "common.success": "Lyckades!",
  "common.cancel": "Avbryt",
  "common.confirm": "Bekräfta",
  "common.save": "Spara",
  "common.edit": "Redigera",
  "common.delete": "Ta bort",
  "common.close": "Stäng",
  "common.back": "Tillbaka",
  "common.next": "Nästa",
  "common.previous": "Föregående",
  "common.search": "Sök",
  "common.filter": "Filtrera",
  "common.sort": "Sortera",
  "common.clear": "Rensa",
  "common.reset": "Återställ",
  "common.submit": "Skicka",
  "common.required": "Obligatoriskt",
  "common.optional": "Valfritt",
  "common.yes": "Ja",
  "common.no": "Nej",
  "common.ok": "OK",
  "common.retry": "Försök igen",

  // Accessibility
  "accessibility.title": "Tillgänglighetsutlåtande",
  "accessibility.section1_title": "Vårt åtagande",
  "accessibility.section1_content":
    "Novi Prints är dedikerade till att säkerställa digital tillgänglighet för personer med funktionsnedsättning. Vi förbättrar kontinuerligt användarupplevelsen för alla och tillämpar relevanta tillgänglighetsstandarder för att uppnå WCAG 2.2 nivå AA-efterlevnad.",
  "accessibility.section2_title": "Efterlevnadsstatus",
  "accessibility.section2_content":
    "Web Content Accessibility Guidelines (WCAG) definierar krav för designers och utvecklare för att förbättra tillgängligheten för personer med funktionsnedsättning. Den definierar tre efterlevnadsnivåer: Nivå A, Nivå AA och Nivå AAA. Novi Prints är delvis efterlevande med WCAG 2.2 Nivå AA. Delvis efterlevande betyder att vissa del av innehållet inte fullt ut följer tillgänglighetsstandarden.",
  "accessibility.section3_title": "Åtgärder för att stödja tillgänglighet",
  "accessibility.section3_content":
    "Novi Prints vidtar följande åtgärder för att säkerställa tillgänglighet: Inkludera tillgänglighet som en del av vårt uppdrag, inkludera tillgänglighet i våra interna policyer, ge kontinuerlig tillgänglighetsutbildning för vår personal, tilldela tydliga tillgänglighetsmål och ansvar, använda formella tillgänglighetskvalitetssäkringsmetoder och inkludera personer med funktionsnedsättning i våra designpersonas.",
  "accessibility.section4_title": "Tangentbordshantering",
  "accessibility.section4_content":
    "Alla interaktiva element kan nås med ett tangentbord. Använd Tab för att navigera framåt, Shift+Tab för att navigera bakåt, Enter eller Space för att aktivera knappar och Escape för att stänga dialogrutor. Fokusindikatorer är synliga med en tydlig kontur för att visa vilket element som för närvarande är i fokus.",
  "accessibility.section5_title": "Skärmläsarstöd",
  "accessibility.section5_content":
    "Vår webbplats är kompatibel med skärmläsare och hjälpmedel. Vi använder semantisk HTML, ARIA-etiketter för ikonknappar, ARIA live-regioner för dynamiska innehållsmeddelanden, korrekt rubrikshierarki och alt-text för alla bilder. Formulärfält är korrekt märkta och felmeddelanden annonseras till skärmläsare.",
  "accessibility.section6_title": "Visuell tillgänglighet",
  "accessibility.section6_content":
    "Vi upprätthåller tillräckliga färgkontrastförhållanden (minst 4.5:1 för normal text, 3:1 för stor text) för att uppfylla WCAG AA-standarden. Text kan förstoras upp till 200% utan funktionsförlust. Vi respekterar inställningen 'prefers-reduced-motion' för att minska animationer för användare som föredrar det. Interaktiva element uppfyller den minsta målsstorleken på 44x44 pixlar för lätt aktivering.",
  "accessibility.section7_title": "WCAG 2.2 uppdateringar (2024-2025)",
  "accessibility.section7_content":
    "Vi har implementerat de nya WCAG 2.2 framgångskriterierna inklusive: Fokus inte dolt (förbättrat) - säkerställer att fokusindikatorer alltid är synliga, Fokus inte dolt (minimum) - fokusindikatorer är åtminstone delvis synliga, Minsta målsstorlek - interaktiva element är minst 24x24 CSS-pixlar (vi överträffar detta med 44x44), och Tillgänglig autentisering - vi tillhandahåller metoder som inte förlitar sig på kognitiva funktionstester.",
  "accessibility.section8_title": "Kända problem och begränsningar",
  "accessibility.section8_content":
    "Trots våra bästa ansträngningar för att säkerställa tillgänglighet kan det finnas vissa begränsningar. Vissa tredjepartsinnehåll (såsom Stripe-betalningsformulär) kan ha varierande nivåer av tillgänglighet. Vi arbetar aktivt med våra tjänsteleverantörer för att förbättra detta. Om du märker några tillgänglighetsbarriärer, kontakta oss med hjälp av feedbackformuläret nedan.",
  "accessibility.section9_title": "Feedback",
  "accessibility.section9_content":
    "Vi välkomnar din feedback om tillgängligheten hos Novi Prints. Vänligen låt oss veta om du stöter på tillgänglighetsbarriärer genom att kontakta oss på info@noviprints.com. Vi strävar efter att svara på tillgänglighetsfeedback inom 5 arbetsdagar.",
  "accessibility.contact_title": "Kontakta oss",
  "accessibility.contact_content":
    "För frågor eller funderingar om tillgänglighet, vänligen kontakta oss på info@noviprints.com.",

  // Footer
  "footer.company": "Novi Prints",
  "footer.description":
    "Professionella 3D-utskriftstjänster med precision och kvalitet.",
  "footer.quick_links": "Snabb länkar",
  "footer.contact": "Kontakt",
  "footer.email": "E-post",
  "footer.phone": "Telefon",
  "footer.copyright": "© 2024 Novi Prints. Alla rättigheter förbehållna.",
  "footer.privacy_policy": "Integritetspolicy",
  "footer.cookie_policy": "Cookie-policy",
  "footer.terms_of_service": "Användarvillkor",
  "footer.accessibility": "Tillgänglighet",
  "footer.email_label": "E-post:",
  "footer.phone_label": "Telefon:",

  // Errors
  "error.network": "Nätverksfel. Kontrollera din internetanslutning.",
  "error.server": "Serverfel. Försök igen senare.",
  "error.not_found": "Sidan hittades inte.",
  "error.unauthorized": "Du har inte behörighet att utföra denna åtgärd.",
  "error.validation": "Vänligen kontrollera dina uppgifter.",
  "error.file_too_large": "Filen är för stor.",
  "error.invalid_file_type": "Ogiltig filtyp.",
  "error.upload_failed": "Uppladdning misslyckades.",
  "error.update_failed": "Uppdatering misslyckades.",
  "error.load_orders": "Kunde inte ladda beställningar.",
  "error.export_failed": "Export misslyckades.",
  "error.delete_failed": "Borttagning misslyckades.",
  "error.logout_failed": "Utloggning misslyckades.",
  "error.load_categories": "Kunde inte ladda kategorier.",
  "error.load_products": "Kunde inte ladda produkter.",
  "error.submit_failed": "Inlämning misslyckades.",

  // Success messages
  "success.item_added_to_cart": "Artikel tillagd i varukorg",
  "success.order_placed": "Beställning lagd",
  "success.profile_updated": "Profil uppdaterad",
  "success.password_changed": "Lösenord ändrat",
  "success.email_sent": "E-post skickat",
  "success.file_uploaded": "Fil uppladdad",
  "success.contact_submitted":
    "Tack! Din förfrågan har skickats. Vi återkommer till dig inom 24 timmar.",

  // Order Confirmation
  "order_confirmation.title": "Beställningsbekräftelse",
  "order_confirmation.thank_you": "Tack för din beställning!",
  "order_confirmation.greeting": "Hej {name},",
  "order_confirmation.received":
    "Din beställning har mottagits och bearbetas. Här är detaljerna:",
  "order_confirmation.order_number": "Beställning #",
  "order_confirmation.items": "Artiklar",
  "order_confirmation.quantity": "Antal",
  "order_confirmation.price": "Pris",
  "order_confirmation.subtotal": "Delsumma",
  "order_confirmation.shipping": "Frakt",
  "order_confirmation.total": "Totalt: {amount} SEK",
  "order_confirmation.shipping_note":
    "Vi skickar dig ett nytt e-postmeddelande när din beställning skickas.",
  "order_confirmation.questions":
    "Om du har några frågor, tveka inte att kontakta oss.",
  "order_confirmation.continue_shopping": "Fortsätt handla",
  "order_confirmation.shipping_address": "Leveransadress",
  "order_confirmation.address": "Adress",
  "order_confirmation.city": "Stad",
  "order_confirmation.postal_code": "Postnummer",
  "order_confirmation.country": "Land",

  // Admin
  "admin.login.title": "Admin-inloggning",
  "admin.login.subtitle": "Logga in för att komma åt adminpanelen",
  "admin.login.email": "E-post",
  "admin.login.password": "Lösenord",
  "admin.login.sign_in": "Logga in",
  "admin.login.error": "Inloggning misslyckades",
  "admin.login.access_denied": "Åtkomst nekad. Adminbehörighet krävs.",

  "admin.dashboard.title": "Instrumentpanel",
  "admin.dashboard.welcome": "Välkommen till Novi Prints adminpanel",
  "admin.dashboard.total_products": "Totalt antal produkter",
  "admin.dashboard.total_orders": "Totalt antal beställningar",
  "admin.dashboard.customers": "Kunder",
  "admin.dashboard.total_revenue": "Totala intäkter",
  "admin.dashboard.active": "aktiva",
  "admin.dashboard.this_week": "denna vecka",
  "admin.dashboard.quick_actions": "Snabbåtgärder",
  "admin.dashboard.create_product": "Skapa produkt",
  "admin.dashboard.view_orders": "Visa beställningar",
  "admin.dashboard.view_customers": "Visa kunder",
  "admin.dashboard.platform_settings": "Plattformsinställningar",

  "admin.nav.dashboard": "Instrumentpanel",
  "admin.nav.products": "Produkter",
  "admin.nav.orders": "Beställningar",
  "admin.nav.customers": "Kunder",
  "admin.nav.categories": "Kategorier",
  "admin.nav.users": "Användare",
  "admin.nav.settings": "Inställningar",
  "admin.nav.sign_out": "Logga ut",

  "admin.products.title": "Produkter",
  "admin.products.create": "Skapa produkt",
  "admin.products.edit": "Redigera produkt",
  "admin.products.name": "Namn",
  "admin.products.category": "Kategori",
  "admin.products.price": "Pris",
  "admin.products.status": "Status",
  "admin.products.active": "Aktiv",
  "admin.products.inactive": "Inaktiv",
  "admin.products.actions": "Åtgärder",
  "admin.products.no_products": "Inga produkter hittades",
  "admin.products.no_products_desc":
    "Skapa din första produkt för att komma igång.",
  "admin.products.loading": "Laddar produkter...",
  "admin.products.delete_confirm":
    "Är du säker på att du vill ta bort denna produkt? Denna åtgärd kan inte ångras.",
  "admin.products.delete_success": "Produkt borttagen",
  "admin.products.delete_error": "Kunde inte ta bort produkt",
  "admin.products.toggle_success": "Produktstatus uppdaterad",
  "admin.products.toggle_error": "Kunde inte uppdatera produktstatus",
  "admin.products.category_required": "Kategori *",
  "admin.products.name_en": "Namn (Engelska) *",
  "admin.products.name_sv": "Namn (Svenska) *",
  "admin.products.description": "Beskrivning",
  "admin.products.description_en": "Beskrivning (Engelska)",
  "admin.products.description_sv": "Beskrivning (Svenska)",
  "admin.products.price_sek": "Pris (SEK) *",
  "admin.products.active_label": "Aktiv (synlig för kunder)",
  "admin.products.images": "Bilder",
  "admin.products.upload_image": "Ladda upp bild",
  "admin.products.uploading": "Laddar upp...",
  "admin.products.options": "Alternativ",
  "admin.products.add_option": "Lägg till alternativ",
  "admin.products.option_name_en": "Alternativnamn (Engelska)",
  "admin.products.option_name_sv": "Alternativnamn (Svenska)",
  "admin.products.option_values": "Värden",
  "admin.products.add_value": "Lägg till värde",
  "admin.products.value_en": "Engelsk etikett",
  "admin.products.value_sv": "Svensk etikett",
  "admin.products.value": "Värde",
  "admin.products.remove_option": "Ta bort alternativ",
  "admin.products.remove_value": "Ta bort",
  "admin.products.save": "Spara ändringar",
  "admin.products.create_btn": "Skapa produkt",
  "admin.products.cancel": "Avbryt",
  "admin.products.save_error": "Kunde inte spara produkt",
  "admin.products.save_success": "Produkt sparad",
  "admin.products.image_url": "Bild-URL",
  "admin.products.no_image": "Ingen bild",
  "admin.products.load_error": "Kunde inte ladda produkt",
  "admin.products.quantity": "Antal",
  "admin.products.details": "Produktdetaljer / Specifikationer",
  "admin.products.details_en": "Detaljer (Engelska)",
  "admin.products.details_sv": "Detaljer (Svenska)",
  "admin.products.details_placeholder":
    "Ange produktdetaljer, specifikationer, funktioner, etc. (HTML stöds)",
  "admin.products.details_hint":
    "Du kan använda HTML-taggar för formatering (t.ex. &lt;ul&gt;, &lt;li&gt;, &lt;table&gt;, &lt;strong&gt;, etc.)",
  "admin.products.option": "Produktalternativ",

  "admin.orders.title": "Beställningar",
  "admin.orders.search": "Sök",
  "admin.orders.search_placeholder":
    "Sök efter beställnings-ID, kundens e-post...",
  "admin.orders.status": "Status",
  "admin.orders.all_statuses": "Alla statusar",
  "admin.orders.status.paid": "Betald",
  "admin.orders.status.processing": "Bearbetas",
  "admin.orders.status.shipped": "Skickad",
  "admin.orders.status.delivered": "Levererad",
  "admin.orders.status.cancelled": "Avbruten",
  "admin.orders.order_id": "Beställnings-ID",
  "admin.orders.customer": "Kund",
  "admin.orders.items": "Artiklar",
  "admin.orders.total": "Totalt",
  "admin.orders.date": "Datum",
  "admin.orders.no_orders": "Inga beställningar hittades",
  "admin.orders.no_orders_desc":
    "Beställningar visas här när kunder lägger dem.",
  "admin.orders.loading": "Laddar beställningar...",
  "admin.orders.view": "Visa detaljer",
  "admin.orders.update_status": "Uppdatera status",
  "admin.orders.update_status_title": "Uppdatera beställningsstatus",
  "admin.orders.new_status": "Ny status *",
  "admin.orders.update": "Uppdatera status",
  "admin.orders.update_success": "Beställningsstatus uppdaterad",
  "admin.orders.update_error": "Kunde inte uppdatera status",
  "admin.orders.tracking_url": "Spårnings-URL",
  "admin.orders.tracking_url_placeholder": "https://tracking.example.com/...",
  "admin.orders.tracking_url_hint":
    "Valfritt: Lägg till en spårnings-URL för skickade beställningar",
  "admin.orders.order_info": "Beställningsinformation",
  "admin.orders.shipping_address": "Leveransadress",
  "admin.orders.order_history": "Beställningshistorik",
  "admin.orders.no_orders_history": "Inga beställningar än.",
  "admin.orders.subtotal": "Delsumma",
  "admin.orders.shipping": "Frakt",
  "admin.orders.item": "artikel",
  "admin.orders.order": "Beställning",
  "admin.orders.no_address": "Ingen adress angiven",

  "admin.customers.title": "Kunder",
  "admin.customers.email": "E-post",
  "admin.customers.name": "Namn",
  "admin.customers.created": "Skapad",
  "admin.customers.no_customers": "Inga kunder hittades",
  "admin.customers.no_customers_desc":
    "Kunder visas här när de skapar ett konto.",
  "admin.customers.loading": "Laddar kunder...",
  "admin.customers.view": "Visa detaljer",
  "admin.customers.edit": "Redigera",
  "admin.customers.delete": "Ta bort",
  "admin.customers.delete_confirm":
    "Är du säker på att du vill ta bort denna kund? Denna åtgärd kan inte ångras.",
  "admin.customers.delete_success": "Kund borttagen",
  "admin.customers.delete_error": "Kunde inte ta bort kund",
  "admin.customers.edit_title": "Redigera kund",
  "admin.customers.customer_info": "Kundinformation",
  "admin.customers.address": "Adress",
  "admin.customers.street": "Gata",
  "admin.customers.street2": "Gata 2",
  "admin.customers.postal_code": "Postnummer",
  "admin.customers.city": "Stad",
  "admin.customers.country": "Land",
  "admin.customers.no_address": "Ingen adress angiven",
  "admin.customers.save": "Spara ändringar",
  "admin.customers.save_success": "Kund uppdaterad",
  "admin.customers.save_error": "Kunde inte uppdatera kund",
  "admin.customers.load_error": "Kunde inte ladda kund",
  "admin.customers.customer": "Kund",

  "admin.categories.title": "Kategorier",
  "admin.categories.create": "Skapa kategori",
  "admin.categories.edit": "Redigera kategori",
  "admin.categories.name_en": "Namn (Engelska) *",
  "admin.categories.name_sv": "Namn (Svenska) *",
  "admin.categories.slug": "Slug *",
  "admin.categories.slug_hint": "Endast små bokstäver, siffror och bindestreck",
  "admin.categories.image_url": "Bild-URL",
  "admin.categories.sort_order": "Sorteringsordning",
  "admin.categories.name": "Namn",
  "admin.categories.slug_label": "Slug",
  "admin.categories.sort": "Sorteringsordning",
  "admin.categories.no_categories": "Inga kategorier hittades",
  "admin.categories.no_categories_desc":
    "Skapa din första kategori för att organisera produkter.",
  "admin.categories.loading": "Laddar kategorier...",
  "admin.categories.delete_confirm":
    "Är du säker på att du vill ta bort denna kategori? Produkter i denna kategori måste omtilldelas.",
  "admin.categories.delete_success": "Kategori borttagen",
  "admin.categories.delete_error": "Kunde inte ta bort kategori",
  "admin.categories.save_success": "Kategori sparad",
  "admin.categories.save_error": "Kunde inte spara kategori",
  "admin.categories.load_error": "Kunde inte ladda kategori",
  "admin.categories.create_error": "Kunde inte skapa kategori",

  "admin.users.title": "Adminanvändare",
  "admin.users.create": "Skapa användare",
  "admin.users.edit": "Redigera användare",
  "admin.users.email": "E-post",
  "admin.users.name": "Namn",
  "admin.users.role": "Roll",
  "admin.users.created": "Skapad",
  "admin.users.no_users": "Inga användare hittades",
  "admin.users.no_users_desc":
    "Skapa din första adminanvändare för att komma igång.",
  "admin.users.loading": "Laddar användare...",
  "admin.users.delete_confirm":
    "Är du säker på att du vill ta bort denna användare? Denna åtgärd kan inte ångras.",
  "admin.users.delete_success": "Användare borttagen",
  "admin.users.delete_error": "Kunde inte ta bort användare",
  "admin.users.create_title": "Skapa adminanvändare",
  "admin.users.password": "Lösenord *",
  "admin.users.password_hint": "Minst 6 tecken",
  "admin.users.create_btn": "Skapa användare",
  "admin.users.create_success": "Användare skapad",
  "admin.users.create_error": "Kunde inte skapa användare",
  "admin.users.save_success": "Användare uppdaterad",
  "admin.users.save_error": "Kunde inte uppdatera användare",
  "admin.users.load_error": "Kunde inte ladda användare",

  "admin.settings.title": "Plattformsinställningar",
  "admin.settings.save": "Spara inställningar",
  "admin.settings.saved": "Sparad!",
  "admin.settings.save_success": "Inställningar sparade",
  "admin.settings.save_error": "Kunde inte spara inställningar",
  "admin.settings.loading": "Laddar inställningar...",
  "admin.settings.shipping": "Frakt",
  "admin.settings.shipping_rate": "Fraktkostnad (SEK) *",
  "admin.settings.gdpr": "GDPR-texter",
  "admin.settings.gdpr_en": "Engelska *",
  "admin.settings.gdpr_sv": "Svenska *",
  "admin.settings.cookie_policy": "Cookie-policy",
  "admin.settings.cookie_en": "Engelska *",
  "admin.settings.cookie_sv": "Svenska *",
  "admin.settings.terms": "Användarvillkor",
  "admin.settings.terms_en": "Engelska *",
  "admin.settings.terms_sv": "Svenska *",

  "admin.common.loading": "Laddar...",
  "admin.common.error": "Ett fel uppstod",
  "admin.common.success": "Lyckades!",
  "admin.common.cancel": "Avbryt",
  "admin.common.save": "Spara",
  "admin.common.edit": "Redigera",
  "admin.common.delete": "Ta bort",
  "admin.common.close": "Stäng",
  "admin.common.remove": "Ta bort",
  "admin.common.required": "Obligatoriskt",
  "admin.common.optional": "Valfritt",
  "admin.common.yes": "Ja",
  "admin.common.no": "Nej",
  "admin.common.active": "Aktiv",
  "admin.common.inactive": "Inaktiv",
  "admin.common.select_category": "Välj en kategori",
  "admin.common.failed_to_load": "Kunde inte ladda",
  "admin.common.na": "Saknas",
};

export default sv;
